import { render, staticRenderFns } from "./MenuWithoutIcons.vue?vue&type=template&id=00201cd4&scoped=true"
import script from "./MenuWithoutIcons.vue?vue&type=script&lang=js"
export * from "./MenuWithoutIcons.vue?vue&type=script&lang=js"
import style0 from "./MenuWithoutIcons.vue?vue&type=style&index=0&id=00201cd4&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00201cd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/viparabclub/releases/20251208210823/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00201cd4')) {
      api.createRecord('00201cd4', component.options)
    } else {
      api.reload('00201cd4', component.options)
    }
    module.hot.accept("./MenuWithoutIcons.vue?vue&type=template&id=00201cd4&scoped=true", function () {
      api.rerender('00201cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/menus/MenuWithoutIcons.vue"
export default component.exports